import api from '@/api';
import {
  PortoScheduleAvailabilityRequest,
  PortoScheduleAvailabilityResponse,
  PortoScheduleConfiguration,
  PortoScheduleConfigurationRequest,
  PortoScheduleUpdateRequest,
} from './porto-schedule.types';

const path = '/workorder/v1/porto-schedule';

export default {
  async scheduleConfigurationList(capsCode?: string) {
    const result = (await api.get(
      `${path}/schedule-configuration/${capsCode}`,
      null,
    )) as unknown;
    return result as PortoScheduleConfiguration;
  },

  async scheduleConfigurationAdd(data: PortoScheduleConfigurationRequest) {
    const result = (await api.post(
      `${path}/schedule-configuration`,
      data,
    )) as unknown;
    return result as void;
  },

  async availability(data: PortoScheduleAvailabilityRequest) {
    const result = (await api.post(`${path}/availability`, data)) as unknown;

    return result as PortoScheduleAvailabilityResponse;
  },

  async update(data: PortoScheduleUpdateRequest) {
    const result = (await api.patch(path, data, null)) as unknown;

    return result as void;
  },
};
